module.exports = __webpack_public_path__ + "static/media/smartphone2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone2.svg
// module id = 918
// module chunks = 0